// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3V6Rb","col":"styles_col__2jqcp","fulfillmentStatus":"styles_fulfillmentStatus__He-gX","emailCol":"styles_emailCol__3E25j"};